import { createFileRoute } from "@tanstack/react-router";
import { ClosesAdmin } from "@/components/Closes/Admin";
import { useParams } from "@/lib/navigation";

function RouteComponent() {
  const params = useParams();
  const id = params?.id as string;
  return <ClosesAdmin id={id} />;
}

export const Route = createFileRoute("/_authenticated/closes/$id/")({
  component: RouteComponent,
  staticData: { page: ["closes", "tax"] },
});
